<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="center" style="margin-top:4em;">To the men of the Allied armies who served in North West Europe 1944-45</p>
<p class="center" style="margin-top:1em;">‘With stout hearts, and with enthusiasm for the contest, let us go forward to victory’<br/>Extract from General B L Montgomery’s personal message to all Allied soldiers on<br/>the eve of D-Day. ‘To be read out to all troops once embarked, June 1944’.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?3731aa5f